import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {CopyrightText} from "./../../utils/constants";
import PortalModal from "./../../alpineComponents/portalModal";

const excludedPages = [
  '/fiveBrainFucks',
  '/thankyou',
  '/subscribe',
  '/toolkit',
  '/sevenDayChallenge',
  '/yearlyAudit',
  'notify',
  'contact'
]

export default class IntroModal extends Component {
  constructor(props) {
      super(props);
      this.state = {introBanner:false}
  }
  componentDidMount = () =>{
    if(excludedPages.indexOf(window.location.pathname) == -1){
      (function(w, d, t, h, s, n) {
        w.FlodeskObject = n;
        var fn = function() {
          (w[n].q = w[n].q || []).push(arguments);
        };
        w[n] = w[n] || fn;
        var f = d.getElementsByTagName(t)[0];
        var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
        var sm = d.createElement(t);
        sm.async = true;
        sm.type = 'module';
        sm.src = h + s + '.mjs' + v;
        f.parentNode.insertBefore(sm, f);
        var sn = d.createElement(t);
        sn.async = true;
        sn.noModule = true;
        sn.src = h + s + '.js' + v;
        f.parentNode.insertBefore(sn, f);
      })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');
      
      window.fd('form', {
        formId: '622ce5ca9b7136a9e313dfa4'
      });
    }
  }
  render() {
    return <span/>
  }
}



// WEBPACK FOOTER //
// ./src/components/introModal/index.js